// import React, { useState } from "react";
// import { Modal, Input, message, Spin, Image, Select } from "antd";
// import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
// import api from "../../context/api";
// import NewsImageUploader from "../imageUploader/NewsImageUploader";
// import "./newscard.scss";

// const { TextArea } = Input;

// const NewsCard = ({ news, onUpdate }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editMode, setEditMode] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     title_uz: news.title_uz,
//     title_ru: news.title_ru,
//     title_en: news.title_en || "",
//     text_uz: news.text_uz || "",
//     text_ru: news.text_ru || "",
//     text_en: news.text_en || "",
//     images: news.images || [],
//   });

//   const deleteNews = async () => {
//     setLoading(true);
//     try {
//       await api.delete(`/news/${news.id}`);
//       message.success("Yangilik muvaffaqiyatli o'chirildi");
//       onUpdate();
//     } catch (error) {
//       console.error("Delete error:", error);
//       message.error(
//         error.response?.data?.message ||
//           "Yangilikni o'chirishda xatolik yuz berdi"
//       );
//     } finally {
//       setLoading(false);
//       setIsModalOpen(false);
//     }
//   };

//   const updateNews = async () => {
//     setLoading(true);
//     const formDataToSend = new FormData();

//     // Append all fields
//     Object.entries(formData).forEach(([key, value]) => {
//       if (key !== "images" && value !== null && value !== undefined) {
//         formDataToSend.append(key, value);
//       }
//     });

//     // Append new images only if they're files (not URLs)
//     formData.images.forEach((image) => {
//       formDataToSend.append('image_files', image); // same as addNews
//     });
    
    
//     try {
//       await api.patch(`/news/${news.id}`, formDataToSend, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       message.success("Yangilik muvaffaqiyatli yangilandi");
//       onUpdate();
//       setIsModalOpen(false);
//     } catch (error) {
//       console.error("Update error:", error);
//       message.error(
//         error.response?.data?.message ||
//           "Yangilikni yangilashda xatolik yuz berdi"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };


  
//   const handleFormChange = (field, value) => {
//     setFormData((prev) => ({ ...prev, [field]: value }));
//   };

//   return (
//     <>
//       <div className="news-card">
//         <div className="card-media">
//           {news.images?.[0] ? (
//             <Image
//               src={news.images[0].image || news.images[0]}
//               alt={news.title_uz}
//               preview={false}
//               style={{
//                 width: "100%",
//                 height: "180px",
//                 objectFit: "cover",
//               }}
//             />
//           ) : (
//             <div className="no-image-placeholder">No Image</div>
//           )}
//           <div className="card-actions">
//             <button
//               onClick={() => {
//                 setEditMode(true);
//                 setIsModalOpen(true);
//               }}
//             >
//               <EditOutlined /> Tahrirlash
//             </button>
//             <button
//               style={{ color: "white", background: "red" }}
//               onClick={() => {
//                 setEditMode(false);
//                 setIsModalOpen(true);
//               }}
//             >
//               <DeleteOutlined /> O'chirish
//             </button>
//           </div>
//         </div>

//         <div className="card-content">
//           <h3>{news.title_uz}</h3>
//           <p>{news.text_uz.substring(0, 100)}...</p>
//           <div className="image-count">
//             <span>{news.images?.length || 0} ta rasm</span>
//           </div>
//         </div>
//       </div>

//       <Modal
//         title={editMode ? "Yangilikni tahrirlash" : "O'chirishni tasdiqlang"}
//         open={isModalOpen}
//         onCancel={() => setIsModalOpen(false)}
//         footer={null}
//         width={editMode ? 800 : 520}
//       >
//         <Spin spinning={loading}>
//           {editMode ? (
//             <div className="edit-form">
//               <div className="current-images">
//               {formData.images?.map((img, index) => {
//   const isFile = img instanceof File;
//   const url = isFile 
//     ? URL.createObjectURL(img)
//     : typeof img === "string"
//       ? img
//       : img.image; // for { id, image } objects

//   return (
//     <div key={index} className="image-preview">
//       <Image
//         src={url}
//         alt={`Preview ${index}`}
//         style={{
//           width: "100px",
//           height: "100px",
//           objectFit: "cover",
//         }}
//       />
//     </div>
//   );
// })}

//               </div>

//               <NewsImageUploader
//                 images={formData.images}
//                 setImages={(images) => handleFormChange("images", images)}
//               />

//               <div className="form-group">
//                 <label>Sarlavha (O'zbekcha)</label>
//                 <Input
//                   value={formData.title_uz}
//                   onChange={(e) => handleFormChange("title_uz", e.target.value)}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Sarlavha (Ruscha)</label>
//                 <Input
//                   value={formData.title_ru}
//                   onChange={(e) => handleFormChange("title_ru", e.target.value)}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Sarlavha (Inglizcha)</label>
//                 <Input
//                   value={formData.title_en}
//                   onChange={(e) => handleFormChange("title_en", e.target.value)}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Matn (O'zbekcha)</label>
//                 <TextArea
//                   rows={4}
//                   value={formData.text_uz}
//                   onChange={(e) => handleFormChange("text_uz", e.target.value)}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Matn (Ruscha)</label>
//                 <TextArea
//                   rows={4}
//                   value={formData.text_ru}
//                   onChange={(e) => handleFormChange("text_ru", e.target.value)}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Matn (Inglizcha)</label>
//                 <TextArea
//                   rows={4}
//                   value={formData.text_en}
//                   onChange={(e) => handleFormChange("text_en", e.target.value)}
//                 />
//               </div>

//               <div className="form-actions">
//                 <button
//                   className="cancel-btn"
//                   onClick={() => setIsModalOpen(false)}
//                 >
//                   Bekor qilish
//                 </button>
//                 <button className="save-btn" onClick={updateNews}>
//                   Saqlash
//                 </button>
//               </div>
//             </div>
//           ) : (
//             <div className="delete-confirmation">
//               <p>Ushbu yangilikni o'chirishni istaysizmi?</p>
//               <div className="confirmation-actions">
//                 <button
//                   className="cancel-btn"
//                   onClick={() => setIsModalOpen(false)}
//                 >
//                   Bekor qilish
//                 </button>
//                 <button className="confirm-delete-btn" onClick={deleteNews}>
//                   O'chirish
//                 </button>
//               </div>
//             </div>
//           )}
//         </Spin>
//       </Modal>
//     </>
//   );
// };

// export default NewsCard;


import React, { useState, useEffect } from "react";
import { Modal, Input, message, Spin, Image } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import api from "../../context/api";
import NewsImageUploader from "../imageUploader/NewsImageUploader";
import "./newscard.scss";

const { TextArea } = Input;

const NewsCard = ({ news, onUpdate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resetUploader, setResetUploader] = useState(0);
  const [formData, setFormData] = useState({
    title_uz: news.title_uz,
    title_ru: news.title_ru,
    title_en: news.title_en || "",
    text_uz: news.text_uz || "",
    text_ru: news.text_ru || "",
    text_en: news.text_en || "",
    images: news.images || [],
  });

  useEffect(() => {
    if (!isModalOpen) {
      setResetUploader(prev => prev + 1);
    }
  }, [isModalOpen]);

  const deleteNews = async () => {
    setLoading(true);
    try {
      await api.delete(`/news/${news.id}`);
      message.success("Yangilik muvaffaqiyatli o'chirildi");
      onUpdate();
    } catch (error) {
      console.error("Delete error:", error);
      message.error(
        error.response?.data?.message ||
          "Yangilikni o'chirishda xatolik yuz berdi"
      );
    } finally {
      setLoading(false);
      setIsModalOpen(false);
    }
  };

  const updateNews = async () => {
    if (formData.images.length === 0) {
      message.error("Iltimos, kamida bitta rasm yuklang");
      return;
    }

    setLoading(true);
    const formDataToSend = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (key !== "images" && value !== null && value !== undefined) {
        formDataToSend.append(key, value);
      }
    });

    formData.images.forEach((image) => {
      if (image instanceof File) {
        formDataToSend.append('image_files', image);
      }
    });
    
    try {
      await api.patch(`/news/${news.id}`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      message.success("Yangilik muvaffaqiyatli yangilandi");
      onUpdate();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Update error:", error);
      message.error(
        error.response?.data?.message ||
          "Yangilikni yangilashda xatolik yuz berdi"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFormChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <>
      <div className="news-card">
        <div className="card-media">
          {news.images?.[0] ? (
            <Image
              src={typeof news.images[0] === 'string' ? news.images[0] : news.images[0].image}
              alt={news.title_uz}
              preview={false}
              style={{
                width: "100%",
                height: "180px",
                objectFit: "cover",
              }}
            />
          ) : (
            <div className="no-image-placeholder">No Image</div>
          )}
          <div className="card-actions">
            <button
              onClick={() => {
                setEditMode(true);
                setIsModalOpen(true);
              }}
            >
              <EditOutlined /> Tahrirlash
            </button>
            <button
              style={{ color: "white", background: "red" }}
              onClick={() => {
                setEditMode(false);
                setIsModalOpen(true);
              }}
            >
              <DeleteOutlined /> O'chirish
            </button>
          </div>
        </div>

        <div className="card-content">
          <h3>{news.title_uz}</h3>
          <p>{news.text_uz?.substring(0, 100) || ''}...</p>
          <div className="image-count">
            <span>{news.images?.length || 0} ta rasm</span>
          </div>
        </div>
      </div>

      <Modal
        title={editMode ? "Yangilikni tahrirlash" : "O'chirishni tasdiqlang"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={editMode ? 800 : 520}
      >
        <Spin spinning={loading}>
          {editMode ? (
            <div className="edit-form">
              <div className="current-images">
                {formData.images?.map((img, index) => {
                  const url = typeof img === 'string' 
                    ? img 
                    : img.image;
                  return (
                    <div key={index} className="image-preview">
                      <Image
                        src={url}
                        alt={`Preview ${index}`}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  );
                })}
              </div>

              <NewsImageUploader
                images={formData.images}
                setImages={(images) => handleFormChange("images", images)}
                resetTrigger={resetUploader}
              />

              <div className="form-group">
                <label>Sarlavha (O'zbekcha)</label>
                <Input
                  value={formData.title_uz}
                  onChange={(e) => handleFormChange("title_uz", e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Sarlavha (Ruscha)</label>
                <Input
                  value={formData.title_ru}
                  onChange={(e) => handleFormChange("title_ru", e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Sarlavha (Inglizcha)</label>
                <Input
                  value={formData.title_en}
                  onChange={(e) => handleFormChange("title_en", e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Matn (O'zbekcha)</label>
                <TextArea
                  rows={4}
                  value={formData.text_uz}
                  onChange={(e) => handleFormChange("text_uz", e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Matn (Ruscha)</label>
                <TextArea
                  rows={4}
                  value={formData.text_ru}
                  onChange={(e) => handleFormChange("text_ru", e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Matn (Inglizcha)</label>
                <TextArea
                  rows={4}
                  value={formData.text_en}
                  onChange={(e) => handleFormChange("text_en", e.target.value)}
                />
              </div>

              <div className="form-actions">
                <button
                  className="cancel-btn"
                  onClick={() => setIsModalOpen(false)}
                >
                  Bekor qilish
                </button>
                <button className="save-btn" onClick={updateNews}>
                  Saqlash
                </button>
              </div>
            </div>
          ) : (
            <div className="delete-confirmation">
              <p>Ushbu yangilikni o'chirishni istaysizmi?</p>
              <div className="confirmation-actions">
                <button
                  className="cancel-btn"
                  onClick={() => setIsModalOpen(false)}
                >
                  Bekor qilish
                </button>
                <button className="confirm-delete-btn" onClick={deleteNews}>
                  O'chirish
                </button>
              </div>
            </div>
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default NewsCard;